export function toggleInList(list: string[], value: string, max?: number): string[] {
  if (list.includes(value)) {
    return list.filter(v => v !== value);
  }
  if (max != null && list.length >= max) {
    return list;
  }
  return [...list, value];
}

/** Which option changed between two PillToggle multiple values (for custom toggle handlers). */
export function pillToggleDelta(prev: string[], next: string[]): string | undefined {
  const added = next.find(x => !prev.includes(x));
  const removed = prev.find(x => !next.includes(x));
  return added ?? removed;
}
